export enum MPU_QUERY {
	HAMS_PRODUCT_KEY = 'confluence.ondemand',
	OFFERING_KEY = '2eda1119-fab4-4699-ab37-ff8f12052cde',
}
